import './css/style.css'
import RoutesNavigation from './routes/RoutesNavigation'

function App() {
  return (
    <div className='App'>
      <RoutesNavigation />
    </div>
  );
}

export default App;
